import type { ColDef } from 'ag-grid-community';
import { mountGrid } from '../components/DataGrid';
import type { AppData, SKU } from '../data/types';

const boolBadge = (v: boolean) =>
  v
    ? '<span class="badge badge-green">✓</span>'
    : '<span class="badge badge-slate">—</span>';

export function renderPortfolio(container: HTMLElement, data: AppData): void {
  const columnDefs: ColDef<SKU>[] = [
    { field: 'SKU', headerName: 'SKU', width: 100, pinned: 'left', cellClass: 'font-mono text-xs' },
    { field: 'Plataforma', width: 160, rowGroup: false, enableRowGroup: true },
    { field: 'Suite', width: 160, enableRowGroup: true },
    { field: 'Producto', width: 200, enableRowGroup: true },
    { field: 'Modulo', headerName: 'Módulo', width: 220 },
    {
      field: 'ListoDesarrollo',
      headerName: 'Desarrollo',
      width: 110,
      cellRenderer: (p: any) => boolBadge(p.value),
      filter: 'agSetColumnFilter',
    },
    {
      field: 'ListaOferta',
      headerName: 'Oferta',
      width: 90,
      cellRenderer: (p: any) => boolBadge(p.value),
    },
    {
      field: 'ListoContrato',
      headerName: 'Contrato',
      width: 100,
      cellRenderer: (p: any) => boolBadge(p.value),
    },
    {
      field: 'ListoSLA',
      headerName: 'SLA',
      width: 80,
      cellRenderer: (p: any) => boolBadge(p.value),
    },
    { field: 'Prioridad', width: 110, enableRowGroup: true },
    { field: 'EsfuerzoEstimado', headerName: 'Esfuerzo', width: 110 },
    { field: 'BTIU', width: 130 },
    { field: 'Pricing', width: 220 },
    { field: 'Herramientas', width: 180 },
    { field: 'Descripcion', headerName: 'Descripción', width: 400, tooltipField: 'Descripcion', wrapText: false },
    { field: 'Ventajas', width: 300 },
    { field: 'Riesgos', width: 300 },
    { field: 'Dependencias', width: 200 },
  ];

  mountGrid<SKU>({
    container,
    rowData: data.skus,
    columnDefs,
    exportFilename: 'portfolio-skus.csv',
    quickFilterPlaceholder: 'Buscar SKU, suite, producto, descripción…',
  });
}
